export default __webpack_public_path__ + "static/media/schools-icon.478e7ab8.svg";